import guest from "@/middleware/guest";
import { routes as termos_tribanco } from "./termos_tribanco";
import { routes as termos_tricard } from "./termos_tricard/";
import { routes as termos_home } from "./termos_home/";
import { routes as somos } from "./somos/";
import { routes as experimente } from "./experimente/";

export default [
  {
      path: "",
      component: () => import(/* webpackChunkName: "DashboardLayout" */ "@/modules/layout/AboutLayout"),
      children: [
          {
              path: "/sobre",
              name: "sobre",
              meta: { middleware: [guest] },
              component: () => import(/* webpackChunkName: "home" */ "./Sobre"),
          },
          ...termos_home,
          ...termos_tribanco,
          ...termos_tricard,
          ...somos,
          ...experimente,
      ]
  },
];
